// initial state
const state = {
  permissionDescPopupInfo: {
    isShow: false,
    title: undefined,
    desc: undefined
  }
}

// getters
const getters = {
  getPermissionDescPopupInfo: (state) => state.permissionDescPopupInfo
}

// mutations
const mutations = {
  SET_PERMISSION_DESC_POPUP_INFO(state, permissionDescPopupInfo) {
    state.permissionDescPopupInfo = permissionDescPopupInfo
  }
}
// actions
const actions = {}

export default {
  state,
  getters,
  actions,
  mutations
}
